import { render, staticRenderFns } from "./TiersListImpayes.vue?vue&type=template&id=4ec6cdda&"
import script from "./TiersListImpayes.vue?vue&type=script&lang=js&"
export * from "./TiersListImpayes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports